import { COMMON_CHANNEL_ID } from '../../../constant/channel';

/**
 * 获取群组频道的key值
 * @param groupId 群id
 * @param channelId 频道id(默认：'#', 非私密频道用户信息共用)
 * @returns 群组频道的key值
 */
function getGroupChannelKey(groupId: string, channelId = COMMON_CHANNEL_ID): string {
  return `${groupId}${channelId}`;
}

export {
  getGroupChannelKey,
};
